import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import logger from "../../../../../../utils/LoggerFrontend";
import { channelsByShortName } from "../../../../../../data/app__channels";
import CampaignCreatePageSelectorClient from "../../../../Previews/PageSelectors/Campaign__Create_PageSelector__Client";
import { PageHeader } from "../print-post-editor-facebook/page-header/PageHeader";
import PrintCampaignCreateTeaserEditor from "../../print-campaign-create-teaser-editor/PrintCampaignCreateTeaserEditor";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const INSTAGRAM_IMAGE_SIZE_SPEC = {
  width: 360,
  height: 640,
  pictureWidth: 360,
  minHeight: 640,
  maxHeight: 640
};
const PostEditorInstagramWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${INSTAGRAM_IMAGE_SIZE_SPEC.width}px;
`;
const InstagramLongWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${INSTAGRAM_IMAGE_SIZE_SPEC.width}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  background: #9ca2ac;
  border-radius: 4px;
  position: relative;
`;
const Bar = styled.div`
  width: 94%;
  height: 3px;
  background: lightgray;
  border-radius: 3px;
  position: relative;
  z-index: 10;
`;

const Progress = styled.div`
  width: 30%;
  height: 3px;
  background: white;
  border-radius: 3px;
  position: absolute;
`;
const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 7px 7px 6px;
  margin-bottom: 40px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
`;
const EditorWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  margin-bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: ${INSTAGRAM_IMAGE_SIZE_SPEC.width}px;
  padding: 0 4px;
`;
const FooterWrapper = styled.div`
  width: 100%;
  margin: 50px 0px 10px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  svg {
    transform: scale(0.5);
  }
`;
const InstagramLearnMoreAnchor = styled.a`
  line-height: 16px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  appearance: none;
  user-select: none;
  cursor: pointer;
  &:hover {
    color: white;
  }
`;
const InstagramLearnMoreArrow = styled.img`
  display: block;
  margin: 0 auto;
  width: 30px;
  border-radius: 100%;
`;
const teaserTextStyle = {
  fontWeight: 600,
  fontSize: "15px",
  lineHeight: "1.3em"
};
//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const PrintPostEditorInstagram = ({
  orgaId,
  postData,
  channelData,
  updatePost,
  adsetId,
  editable,
  updateChannelData,
  selectedCreativeIndexToEdit,
  mediaAssets,
  mediaAssetsProps
}) => {
  const { t } = useTranslation();

  logger.debug("PostEditorInstagram:render", "render:", {
    postData,
    channelData,
    updatePost,
    editable
  });

  const minAspect = channelsByShortName.instagram.minAspect;
  const maxAspect = channelsByShortName.instagram.maxAspect;

  const templatePreviewSizes = {
    minHeight: INSTAGRAM_IMAGE_SIZE_SPEC.minHeight,
    maxHeight: INSTAGRAM_IMAGE_SIZE_SPEC.maxHeight,
    width: INSTAGRAM_IMAGE_SIZE_SPEC.pictureWidth,
    minAspect: minAspect,
    maxAspect: maxAspect
  };

  return (
    <PostEditorInstagramWrapper>
      <InstagramLongWrapper>
        <Header style={{ zIndex: 2 }}>
          <Bar>
            <Progress />
          </Bar>
          <CampaignCreatePageSelectorClient
            updateChannelData={updateChannelData}
            pageId={channelData?.pageId}
            adsetId={adsetId}
            editable={false}
          >
            <PageHeader
              pageLogo={channelData?.pageLogo}
              pageName={channelData?.pageName}
              pageId={channelData?.pageId}
              sponsoredLogo
            />
          </CampaignCreatePageSelectorClient>
        </Header>
        <PrintTemplateEditor
          orgaId={orgaId}
          selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          mediaAssets={mediaAssets}
          mediaAssetsProps={mediaAssetsProps}
          templatePreviewSizes={templatePreviewSizes}
        />
        <EditorWrapper style={{ zIndex: 2 }}>
          <PrintCampaignCreateTeaserEditor
            channel="instagram"
            updatePost={updatePost}
            teaserText={postData.teaserText}
            teaserTextStyle={teaserTextStyle}
            smallButtons
            minRows={4}
            editable={editable}
            isAutoGenerated={postData?.isAutoGenerated}
            autoGeneratedText={postData?.autoGeneratedText}
            isEdited={postData?.editedStates?.teaserText}
          />
        </EditorWrapper>
        <FooterWrapper style={{ zIndex: 2 }}>
          <InstagramLearnMoreAnchor target="_blank" href={channelData.url}>
            <InstagramLearnMoreArrow src="/images/arrow_up.png" alt="" />
            {t("Learn more")}
          </InstagramLearnMoreAnchor>
        </FooterWrapper>
      </InstagramLongWrapper>
    </PostEditorInstagramWrapper>
  );
};

export default PrintPostEditorInstagram;
